var _circle, _rect, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _rect2, _rect3, _rect4, _circle7, _circle8, _circle9, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 221,
    viewBox: "0 0 293 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 110.5,
    r: 109.5,
    fill: "#F8F7FE",
    stroke: "#A2A1B2",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 51,
    width: 196,
    height: 133,
    rx: 7,
    fill: "white",
    stroke: "#A2A1B2",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 108,
    r: 5,
    fill: "#A2A1B2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 59.5,
    r: 1.5,
    fill: "#A2A1B2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 59.5,
    r: 1.5,
    fill: "#A2A1B2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 59.5,
    r: 1.5,
    fill: "#A2A1B2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 108,
    r: 5,
    fill: "#A2A1B2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 242,
    y1: 67,
    x2: 47,
    y2: 67,
    stroke: "#A2A1B2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    width: 5,
    height: 35,
    rx: 2.5,
    fill: "#A2A1B2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 52,
    width: 5,
    height: 35,
    rx: 2.5,
    transform: "rotate(90 293 52)",
    fill: "#A2A1B2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 275.749,
    y: 15,
    width: 5,
    height: 35,
    rx: 2.5,
    transform: "rotate(45 275.749 15)",
    fill: "#A2A1B2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 143.5,
    r: 10.5,
    fill: "#F8F7FE"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 17.5,
    r: 5.5,
    fill: "#F8F7FE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 95.5,
    r: 5.5,
    fill: "#F8F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.998 147.257C157.977 148.361 158.856 149.273 159.961 149.293C161.065 149.313 161.977 148.435 161.997 147.33L157.998 147.257ZM150.292 132.289L149.506 134.128L150.292 132.289ZM126 147C126 148.104 126.895 149 128 149C129.105 149 130 148.104 130 147L126 147ZM161.997 147.33C162.041 144.953 161.613 142.59 160.738 140.379L157.019 141.851C157.699 143.57 158.032 145.408 157.998 147.257L161.997 147.33ZM160.738 140.379C159.864 138.168 158.56 136.153 156.902 134.448L154.035 137.238C155.324 138.563 156.338 140.131 157.019 141.851L160.738 140.379ZM156.902 134.448C155.244 132.744 153.265 131.385 151.079 130.45L149.506 134.128C151.206 134.855 152.745 135.912 154.035 137.238L156.902 134.448ZM151.079 130.45C148.892 129.515 146.543 129.022 144.165 129.001L144.128 133C145.978 133.017 147.805 133.401 149.506 134.128L151.079 130.45ZM144.165 129.001C141.788 128.979 139.429 129.428 137.226 130.323L138.732 134.029C140.445 133.333 142.279 132.984 144.128 133L144.165 129.001ZM137.226 130.323C135.023 131.218 133.02 132.54 131.331 134.214L134.146 137.055C135.46 135.753 137.018 134.725 138.732 134.029L137.226 130.323ZM131.331 134.214C129.642 135.887 128.301 137.879 127.386 140.073L131.078 141.613C131.79 139.906 132.832 138.357 134.146 137.055L131.331 134.214ZM127.386 140.073C126.471 142.268 126 144.622 126 147L130 147C130 145.151 130.366 143.32 131.078 141.613L127.386 140.073Z",
    fill: "#A2A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/not_found_icon.56e338c2304b6f86bb7733b82a3001ac.svg";
export { ForwardRef as ReactComponent };